export class ProjectOwnerDetailsModel {
    constructor() {
        this.assignedAll = false;
        this.assignedProjects = [];
        this.assignedMembers = [];
        this.userId = null;
    }
}
export default class ProjectOwnerDetails extends ProjectOwnerDetailsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
